
import CheckoutPayment from '~/pages/_lang/checkout/payment/_tempId.vue'
export default CheckoutPayment
